var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-tab-item', {
    staticClass: "fill-height"
  }, [_c('div', {
    staticClass: "text-center mb-20 mb-lg-40"
  }, [_c('h3', {
    staticClass: "tit mb-8 mb-lg-16"
  }, [_vm._v("미팅진행 공고 선택")]), _c('p', {
    staticClass: "page-text--lg grey-6--text"
  }, [_vm._v("면접을 진행할 공고를 선택한 후 다음 단계로 넘어가 주세요.")])]), _c('v-sheet', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll.self",
      value: _vm.loadMore,
      expression: "loadMore",
      modifiers: {
        "self": true
      }
    }],
    staticClass: "w-100 scroll-primary pr-10",
    staticStyle: {
      "overflow-y": "auto"
    },
    style: _vm.$vuetify.breakpoint.mdAndUp ? 'max-height: 460px;' : 'max-height: 320px;'
  }, [_c('div', {
    staticClass: "v-cards"
  }, _vm._l(_vm.items, function (item) {
    var _vm$value, _item$qualification, _item$qualification$w;
    return _c('v-card', {
      key: item._id,
      staticClass: "recruitment-item",
      attrs: {
        "rounded": "lg",
        "outlined": ""
      },
      on: {
        "click": function click($event) {
          return _vm.$emit('input', item);
        }
      }
    }, [_c('div', {
      staticClass: "pa-20 pa-md-24"
    }, [_c('v-row', {
      staticClass: "row--large",
      attrs: {
        "align": "center"
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "auto"
      }
    }, [_c('v-simple-checkbox', {
      attrs: {
        "value": ((_vm$value = _vm.value) === null || _vm$value === void 0 ? void 0 : _vm$value._id) == (item === null || item === void 0 ? void 0 : item._id),
        "color": "primary"
      },
      on: {
        "click": function click($event) {
          return _vm.$emit('input', item);
        }
      }
    })], 1), _c('v-col', {
      staticClass: "recruitment-item__contents"
    }, [_c('h5', {
      staticClass: "page-text--lg font-wieght-medium mb-8 mb-lg-16"
    }, [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : item.subject) + " ")]), _c('v-chip-group', {
      staticClass: "mb-4"
    }, _vm._l((item === null || item === void 0 ? void 0 : (_item$qualification = item.qualification) === null || _item$qualification === void 0 ? void 0 : (_item$qualification$w = _item$qualification.workExperience) === null || _item$qualification$w === void 0 ? void 0 : _item$qualification$w.texts) || [], function (text) {
      return _c('v-chip', {
        key: text,
        attrs: {
          "small": "",
          "outlined": "",
          "color": "grey-d"
        }
      }, [_c('span', {
        staticClass: "grey-6--text"
      }, [_vm._v(" " + _vm._s(text) + " ")])]);
    }), 1), _c('p', {
      staticClass: "page-text grey-6--text ellip mb-8 mb-lg-16"
    }, [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : item.summary) + " ")]), _c('recruitment-view-application', _vm._b({}, 'recruitment-view-application', item, false))], 1)], 1)], 1)]);
  }), 1)]), _c('v-fade-transition', [_c('v-overlay', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.loading,
      expression: "loading"
    }],
    attrs: {
      "absolute": "",
      "color": "white"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "color": "black",
      "size": "100",
      "width": "5",
      "indeterminate": ""
    }
  })], 1)], 1), _c('div', {
    staticClass: "v-btn-group"
  }, [_c('v-btn', {
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('next');
      }
    }
  }, [_c('span', [_vm._v("다음으로")])])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }